/* istanbul ignore file */
export enum ReduxTypesEnum {
    RESET = 'reset'
}
